import { ProgressStep } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/Progress/_shared/types';

export class ProgressPercentage {
  private readonly _visibleProgressSteps: ProgressStep[];
  private readonly _currentStep: ProgressStep;
  private readonly _isApplicationCompleted: boolean;
  private readonly _percentage: number;

  constructor(visibleProgressSteps: ProgressStep[], currentStep: ProgressStep, isApplicationCompleted: boolean) {
    this._visibleProgressSteps = visibleProgressSteps;
    this._currentStep = currentStep;
    this._isApplicationCompleted = isApplicationCompleted;
    this._percentage = this.calculateProgressPercentage();
  }

  private calculateProgressPercentage(): number {
    if (this._isApplicationCompleted) {
      return 100;
    }

    const numberOfProgressSteps = this._visibleProgressSteps.length;

    const currentStepIndex = this._visibleProgressSteps.findIndex((el) => this._currentStep.status === el.status);

    return ((currentStepIndex + 1) / numberOfProgressSteps) * 100;
  }

  public get percentage(): number {
    return this._percentage;
  }
}
